import { searchPageApi } from '../../../../../api/searchPageApi';

import { useMakeModelContext } from '../../../../../components/SearchPage/features/makeModel/MakeModelContext';

import {
  mapModelOptions,
  mapTrimOptions,
} from '../../../../../components/SearchPage/features/makeModel/MakeModel.map';

import { fireToast } from '../../../../../helpers/Toasts';
import { IGetAdsRequest } from '../../../../../api/types/searchPageApiTypes';
import { rg4js } from '../../../../../helpers/raygun';
import { PAGE } from '../../../../../helpers/pages';
import getConfig from 'next/config';

type MakeModelSharedArgs = { section: string };

const useMakeModelShared = (args: MakeModelSharedArgs) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  const { section } = args;

  const { addModelOptions, addTrimOptions, setModelsLoading } =
    useMakeModelContext();

  const getModels = async (makeValue: string) => {
    try {
      const {
        data: { all, popular },
      } = await searchPageApi.getModelByMake(section, makeValue);
      const mappedOptions = mapModelOptions(all, popular);
      addModelOptions(mappedOptions);
    } catch (_error) {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  };

  const getModelsWithCounts = async (
    makeValue: string,
    payload: IGetAdsRequest,
  ) => {
    setModelsLoading(true);
    try {
      const {
        data: { all, popular },
      } = await searchPageApi.getModelByMakeWithCounts({
        section,
        make: makeValue,
        payload,
        timeout: API_CLIENT_TIMEOUT,
      });
      const mappedOptions = mapModelOptions(all, popular);
      addModelOptions(mappedOptions);
      setModelsLoading(false);
    } catch (error) {
      setModelsLoading(false);
      if (error instanceof Error) {
        rg4js('send', {
          error,
          tags: [PAGE.SEARCH],
          customData: {
            message: 'Error handling getModelByMakeWithCounts',
          },
        });
      }
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  };

  const getTrimsWithCount = async (
    makeValue: string,
    modelValue: string,
    payload: IGetAdsRequest,
  ) => {
    try {
      const {
        data: { all, popular },
      } = await searchPageApi.getTrimByMakeModelWithCount({
        section,
        make: makeValue,
        model: modelValue,
        payload,
        timeout: API_CLIENT_TIMEOUT,
      });

      const mappedOptions = mapTrimOptions(all, popular);
      addTrimOptions(mappedOptions);
    } catch (error) {
      if (error instanceof Error) {
        rg4js('send', {
          error,
          tags: [PAGE.SEARCH],
          customData: {
            message: 'Error handling getTrims',
          },
        });
      }
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  };

  return {
    getModels,
    getTrimsWithCount,
    getModelsWithCounts,
  };
};

export { useMakeModelShared };
